import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { instance } from "../../Actions/AxiosInstance";

export default class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldpassword: "",
      newpassword: "",
      confirmnewpass: "",
      showOldPassword: false,
      showNewPassword: false,
      showNewConfirmPassword: false,
    };
    this.updateOldPass = this.updateOldPass.bind(this);
    this.updateNewPass = this.updateNewPass.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.updateConfirmNewPass = this.updateConfirmNewPass.bind(this);
    this.handleClickShowPassword = this.handleClickShowPassword.bind(this);
  }

  updateOldPass(e) {
    this.setState({ oldpassword: e.target.value });
  }

  handleClickShowPassword(type) {
    if (type == 1) {
      this.setState((state) => ({ showPassword: !state.showPassword }));
    } else if (type == 2) {
      this.setState((state) => ({ showNewPassword: !state.showNewPassword }));
    } else {
      this.setState((state) => ({
        showNewConfirmPassword: !state.showNewConfirmPassword,
      }));
    }
  }

  updateNewPass(e) {
    this.setState({ newpassword: e.target.value });
  }

  updateConfirmNewPass(e) {
    this.setState({ confirmnewpass: e.target.value });
  }

  onSubmit() {
    const data = {
      oldpassword: this.state.oldpassword,
      newpassword: this.state.newpassword,
    };
    if (
      data.oldpassword == "" ||
      data.newpassword == "" ||
      this.state.confirmnewpass == ""
    ) {
      this.props.enqueueSnackbar("Please fill all required fields", {
        variant: "error",
      });
      return;
    }
    const URL = `account/changepassword`;
    instance
      .post(URL, data)
      .then(() => {
        const DATA = {
          ...this.props.AuthenticationAction.login,
          isfirstlogin: false,
        };
        this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
          IsFulfilled: true,
          data: DATA,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  render() {
    const { oldpassword, newpassword, confirmnewpass } = this.state;
    const newpasserr =
      newpassword && (newpassword.length < 8 || newpassword == oldpassword);
    const confirmnewpasserr = confirmnewpass && confirmnewpass != newpassword;
    return (
      <div
        style={{
          width: 298,
          height: 380,
          boxShadow: "0 3px 12px 0 rgba(0, 0, 0, 0.16)",
          padding: 32,
        }}
      >
        <DialogTitle style={{ padding: 0 }}>
          <span
            className="t-bold"
            style={{ fontSize: 19, color: "#010709", display: "block" }}
          >
            Reset your password
          </span>
          <span
            style={{ fontSize: 14, color: "rgba(1,7,9,0.7)", display: "block" }}
          >
            🔑 Secure your account with a new password
          </span>
        </DialogTitle>
        <DialogContent style={{ padding: 0, paddingTop: 24 }}>
          <FormControl className="width100">
            <div className="margin-bottom-16 mui-textfield">
              <p className="input-label">Old password</p>
              <TextField
                autoComplete={false}
                // type="password"
                type={this.state.showPassword ? "text" : "password"}
                className="width100"
                variant="outlined"
                placeholder="Old Password"
                onChange={this.updateOldPass}
                value={oldpassword}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        className="ShowPassword"
                        aria-label="Toggle password visibility"
                        onClick={() => this.handleClickShowPassword(1)}
                      >
                        {this.state.showPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="mui-textfield margin-bottom-8">
              <p className="input-label">New password</p>
              <TextField
                type={this.state.showNewPassword ? "text" : "password"}
                variant="outlined"
                className="width100"
                placeholder="New Password"
                onChange={this.updateNewPass}
                value={newpassword}
                error={newpasserr}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        className="ShowPassword"
                        aria-label="Toggle password visibility"
                        onClick={() => this.handleClickShowPassword(2)}
                      >
                        {this.state.showNewPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <p
                style={{
                  color: "rgba(1,7,9,0.7)",
                  fontSize: "0.75rem",
                  marginTop: 4,
                }}
              >
                {newpasserr && newpassword.length < 8
                  ? "Minimum 8 characters, please 🙏"
                  : newpasserr && newpassword == oldpassword
                  ? "Can not be same"
                  : " "}
              </p>
            </div>
            <div className="mui-textfield margin-bottom-8">
              <p className="input-label">Confirm new password</p>
              <TextField
                type={this.state.showNewConfirmPassword ? "text" : "password"}
                className="width100"
                variant="outlined"
                placeholder="Confirm New Password"
                onChange={this.updateConfirmNewPass}
                value={confirmnewpass}
                error={confirmnewpasserr}
                // helperText={confirmnewpasserr ? "must be same" : " "}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        className="ShowPassword"
                        aria-label="Toggle password visibility"
                        onClick={() => this.handleClickShowPassword(3)}
                      >
                        {this.state.showNewConfirmPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <p
                style={{
                  color: "rgba(1,7,9,0.7)",
                  fontSize: "0.75rem",
                  marginTop: 4,
                }}
              >
                {confirmnewpasserr ? "must be same" : " "}
              </p>
            </div>
            <div style={{ padding: "10px 0px 24px 0px", textAlign: "right" }}>
              <Button
                className="text-align-right btn btn-primary-sm-blue"
                style={{ width: 85 }}
                color="primary"
                variant="contained"
                onClick={this.onSubmit}
                disabled={
                  !oldpassword ||
                  !newpassword ||
                  newpasserr ||
                  confirmnewpasserr
                }
              >
                Update
              </Button>
            </div>
          </FormControl>
        </DialogContent>
      </div>
    );
  }
}
